<template>
  <div>
    <ok-cancel-modal
      :title="$t('health.corporateGroups.addCorporateGroup')"
      :ok-button="$t('commons.ok')"
      :cancel-button="$t('commons.cancel')"
      v-on:ok="onOk"
      v-on:cancel="$emit('close')">
      <div
        slot="body">

        <div class="variable-input-field">
          <label-select
            :label="$t('health.corporateGroups.group')"
            v-model="selectedGroup"
            v-on:input="changeGroup"
            :options="groupOptions"
            form-size="m"
            class="margin-right-s">
          </label-select>
        </div>

        <div class="variable-input-field variable-input-field-name">
          <label-input
            ref="domainInput"
            form-size="m"
            :label="$t('health.corporateGroups.domainWithoutAt')"
            v-model="domain"
            :type="'text'"
            :error="domainError"
            :errorMessage="$t('health.corporateGroups.invalidDomain')">
          </label-input>
        </div>

        <checkbox
          id="active-plan"
          :label="$t('health.corporateGroups.activePlan')"
          v-on:change="onActivePlanChange"
          :checked="activePlan">
        </checkbox>

      </div>
    </ok-cancel-modal>
  </div>
</template>

<script>
import LabelInput from '@/components/shared/forms/LabelInput';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import SearchInput from '@/components/shared/SearchInput';
import Checkbox from '@/components/shared/forms/Checkbox';
import LabelSelect from '@/components/shared/forms/LabelSelect';
import vSelect from 'vue-select';

export default {
  name: 'AddCorporateGroupModal',
  components: {
    OkCancelModal,
    SearchInput,
    Checkbox,
    LabelInput,
    LabelSelect,
    vSelect
  },
  props: {
    groupOptions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      groupId: '',
      name: '',
      domain: '',
      activePlan: false,
      domainError: false,
      selectedGroup: undefined
    };
  },
  created () {
    this.$nextTick(() => {
      this.$refs.domainInput.focus();
    });
  },
  methods: {
    onOk () {
      const updatedGroup = {
        groupId: this.groupId,
        name: this.name,
        domain: this.domain,
        activePlan: this.activePlan
      };
      this.$emit('input', updatedGroup);
      this.$emit('close');
    },
    onActivePlanChange (value) {
      this.activePlan = value;
    },
    changeGroup (value) {
      this.groupId = value.value;
      this.name = value.label;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";

h3 {
  color: $jamaicol;
}

.plan-list {
  min-height: calc(100vh / 2);
  max-height: calc(100vh / 2);
  overflow-y: auto;
}

.search-input {
  margin-bottom: $sp-margin;
}

.full-width {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/corporateGroups/AddCorporateGroupModal.vue